export default "__VITE_ASSET__CaU1VqBQ__"